exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".btn-danger[data-v-57cc50e6] {\n  background: #dc3545 !important;\n  color: white;\n}\n@media screen and (max-width: 750px) {\n.v-btn[data-v-57cc50e6] {\n    min-width: 60px !important;\n    margin: 0 0 0 3px;\n}\n}", ""]);

// exports
